import chunkArray from '@cartwhl/common/utils/chunkArray';

import {
  Job,
  JobFromAPI,
  Project,
  ProjectFromAPI,
  SystemChatRecord,
  UserChatRecord,
} from '../types';
import { notEmpty } from './api-utils';

export function transformJob(job?: JobFromAPI): Job | undefined {
  if (!job) return undefined;

  job.chatHistory = job.chatHistory || [
    // Backwards compatibility for chatHistory
    // Scoot is going to start populating the chatHistory
    // Can be removed once AT project is live
    {
      type: 'USER',
      prompt: job.prompt,
    },
  ];

  return {
    ...job,
    chatHistory: chunkArray(job.chatHistory, 2) as [
      UserChatRecord,
      SystemChatRecord,
    ][],
  };
}

export function transformJobs(jobs?: JobFromAPI[]): Job[] {
  return jobs?.map(transformJob).filter(notEmpty) ?? [];
}

export function transformProject(
  project?: ProjectFromAPI,
): Project | undefined {
  if (!project) return undefined;

  // Remove certain keys that are not needed in studio
  const { PK, SK, accessLevel, accessorID, ...projectWithoutCertainKeys } =
    project;
  return {
    ...projectWithoutCertainKeys,
  };
}

export function transformProjects(projects?: ProjectFromAPI[]): Project[] {
  return projects?.map(transformProject).filter(notEmpty) ?? [];
}

export function transformProjectResponse(
  project?: ProjectFromAPI,
): Project | undefined {
  if (!project) return undefined;

  return { ...project };
}
